import { SENSORTOWER_METRIC_KEY_MAP } from '@intelligence/v3/_config/metrics/keyMap';

export interface ISortableMetricColumnMetaData {
  // 简短列名，目前在数据源icon的hover浮窗里用到的
  simpleName: string;
  // 列宽
  width: number;
  // 列名hover浮窗的第一行文案
  content?: string;
  // 列名hover浮窗的第二行文案
  tipText?: string;
}

// 宽表指可排序指标列 展示文案的配置
export const SORTABLE_METRICS_COLUMNS_METADATAS_MAPPING: {
  [key: string]: ISortableMetricColumnMetaData;
} = {
  [SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE]: {
    simpleName: '',
    width: 240,
    content: 'dbi_overlapanylistis_crossusage_tabletip',
    tipText: '',
  },
  [SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY]: {
    simpleName: '',
    width: 240,
    content: 'dbi_overlapanylistis_crossaffinity_tabletip',
    tipText: '',
  },
};
